import { useEffect, useState } from "react";

function SalesPopup({ products=[] }) {

const [sale,setSale] = useState(null);

useEffect(()=>{
if(products.length===0) return;

const interval = setInterval(()=>{

  const randomProduct =
    products[Math.floor(Math.random()*products.length)];

  setSale({
    name:"Someone",
    product:randomProduct.name
  });

  setTimeout(()=>setSale(null),4000);

},15000);

return ()=>clearInterval(interval);
},[products]);

if(!sale) return null;

return (
<div className="fixed bottom-6 left-6 bg-white shadow-lg rounded-lg px-5 py-3 border text-sm">

  <p>
    <b>{sale.name}</b> bought
    <br/>
    {sale.product}
  </p>

</div>
);

}

export default SalesPopup;
